'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function AssessmentWhiteScreenAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-json/assessment-instructions-white-screen-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="AssessmentWhiteScreenAnimation"
    />
  );
}
